module.exports = __webpack_public_path__ + "static/media/phantom-gourmet.2ce104b6.png";